/* LK-REFILL v2 (2026-09-29, Jume): the refill now goes in as ONE LINE PER COLOR of "LoveSKN Refill Nails (nails only)"
   (SKU LK-NAIL-<DESIGN>-Short|Long, the design photo, qty = sets of that design), priced per set by refill size
   (Refill of 1..6 = $9 / 7.50 / 6.33 / 5.75 / 5.20 / 4.83), so Jume's system matches every line. In this drawer the color
   lines of one refill are shown as ONE row (designs, sets, total, one Remove).
   v3 (2026-09-30, Jume): the color lines carry NO line properties at all (Jume's system showed the hidden _rf and the
   duplicated design/length under every line). Design and length come from the variant title "Design / Length / Refill of N",
   and a refill belongs to the kit whose designs+length match its lines (kit removed or changed -> its lines removed).
   Old lines that still carry properties are grouped the same way. Old "Refill Sets" lines still handled as before.
   v1 notes follow. */
/* LK-REFILL v1 (2026-09-28): "Your first refill, ready" row under each kit line in the cart drawer.
   One tap adds LoveSKN Refill Sets (nails only) carrying the kit line's exact designs + length,
   so the refill line reads like the kit line and the order note counts its sets for Jume.
   A/B test refill_row_v1: a = today's drawer, b = drawer + row. Preview: always b, nothing counted.
   Data comes from #lk-rf-data (Liquid, prices in the shopper's currency). */
/* ONE CART CHANGE AT A TIME (2026-09-28). Shopify can drop one of two cart changes that land together: reproduced on
   the live store, a line removal racing a kit add lost the kit (the owner saw a cart with only the remover). Every POST to
   /cart/add|change|update|clear on this page now waits for the previous one (8 s safety valve so a hung request can't
   block the cart). Covers the drawer, the pop-up, the bumps, the note and this file. */
(function () {
  var f = window.fetch; if (!f || f.__lkQueued) return;
  var chain = Promise.resolve();
  var q = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (m === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) {
      var self = this, args = arguments;
      var gate = Promise.race([chain, new Promise(function (r) { setTimeout(r, 8000); })]);
      var p = gate.then(function () { return f.apply(self, args); });
      chain = p.then(function () {}, function () {});
      return p;
    }
    return f.apply(this, arguments);
  };
  q.__lkQueued = true; window.fetch = q;
})();

(function () {
  var el = document.getElementById('lk-rf-data'); if (!el) return;
  var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var TEST = 'refill_row_v1', KEY = 'lkab_refill_v1', ATTR = '_ab_refill_row_v1';

  var q = ''; try { q = (new URLSearchParams(location.search).get('lkrf') || '').toLowerCase(); } catch (e) {}
  var forced = (q === 'a' || q === 'b'), v = null;
  /* TEST ENDED 2026-09-28 (owner: "put it live for everyone"): every visitor gets the refill row.
     Counting continues (all 'b') so the take rate stays measurable; ?lkrf=a still shows the old cart for QA. */
  v = forced ? q : 'b';
  window.__lkRefill = v;
  if (D.preview) { try { localStorage.setItem('lk_prev_cart', '1'); } catch (e) {} }   /* lets the owner's phone test the site-wide cart icon before go-live */

  var counting = !!D.counter && !forced && !D.preview;
  function ping(ev) {
    if (!counting) return;
    try { new Image().src = D.counter + '?t=' + TEST + '&v=' + v + '&e=' + ev + '&_=' + Date.now(); } catch (e) {}
  }
  function once(ev) {
    try { if (sessionStorage.getItem(KEY + '_' + ev)) return; sessionStorage.setItem(KEY + '_' + ev, '1'); } catch (e) {}
    ping(ev);
  }
  once('view');

  var css = '#lk-drawer .lkrf-row{position:relative;display:flex;align-items:center;gap:8px;margin:6px 0 6px;padding:8px 5px 5px 10px;border:1.5px dashed #e8a6c1;border-radius:11px;background:#fff6fa}'
    + '#lk-drawer .lkrf-tx{flex:1;min-width:0;font-size:13px;line-height:1.3;color:#5e4f55}'
    + '#lk-drawer .lkrf-tx b{display:block;font-size:14px;line-height:1.25;color:#2b2226;margin:0 0 2px}'
    + '#lk-drawer .lkrf-add{flex:none;border:0;border-radius:9px;background:#a8235a;color:#fff;font-family:inherit;font-weight:800;font-size:14px;line-height:1;padding:0 12px;min-height:42px;cursor:pointer;white-space:nowrap}'
    /* compact cart lines (both test groups): less padding; add-ons (remover, glue) on one tidy row */
    + '#lk-drawer #lk-ditems > .lk-ditem{padding-top:10px!important;padding-bottom:10px!important}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-c{align-items:center}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-c .lk-diname{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-c .lk-diqty{margin-top:3px}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-c > img{width:48px!important;height:48px!important;min-width:48px!important}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-q1 .lk-diqty > button:not(.lk-dirm),#lk-drawer #lk-ditems > .lk-ditem.lkrf-q1 .lk-diqty > span{display:none!important}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-q1 .lk-diqty .lk-dirm{margin-left:0!important}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-k .lk-dimeta > .lk-diprops:nth-last-child(2){display:inline-block;margin-right:12px}'
    + '#lk-drawer #lk-ditems > .lk-ditem:first-child{padding-top:6px!important}'
    /* readability for a 55-75 audience: designs / length / Remove were 11px */
    + '#lk-drawer #lk-ditems .lk-diprops{font-size:13px!important;line-height:1.35!important}#lk-drawer #lk-ditems .lk-dirm{font-size:13px!important}'
    + '#lk-drawer > #lk-ship{margin-top:5px!important}#lk-drawer > #lk-rewards{margin-top:3px!important;margin-bottom:0!important}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-k .lk-dimeta > .lk-diqty{display:inline-flex;vertical-align:baseline;margin:0!important}'
    + '#lk-drawer .lkrf-add[disabled]{opacity:.6;cursor:default}'
    /* v2 refill row: Remove next to Length, like the kit line (one text line shorter) */
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-g .lk-dimeta > .lk-diprops:nth-last-child(2){display:inline-block;margin-right:12px}'
    + '#lk-drawer #lk-ditems > .lk-ditem.lkrf-g .lk-dimeta > .lk-diqty{display:inline-flex;vertical-align:baseline;margin:0!important}'
    + '#lk-drawer .lkrf-flag{position:absolute;top:-14px;left:12px;background:#a8235a;color:#fff;font-family:inherit;font-size:11.5px;font-weight:800;letter-spacing:.6px;text-transform:uppercase;line-height:1;padding:4px 10px;border-radius:999px;white-space:nowrap}'
    + '#lk-drawer .lkrf-mo{display:grid;gap:2px;overflow:hidden;background:#fff;flex:none;box-sizing:border-box}'
    + '#lk-drawer .lk-ditem .lkrf-mo img{width:100%!important;height:100%!important;min-width:0!important;object-fit:cover;display:block;border-radius:0!important;margin:0!important;border:0!important}'
    + '#lk-drawer .lkrf-mo1{grid-template:1fr/1fr}#lk-drawer .lkrf-mo2{grid-template:1fr/1fr 1fr}'
    + '#lk-drawer .lkrf-mo3,#lk-drawer .lkrf-mo4{grid-template:1fr 1fr/1fr 1fr}#lk-drawer .lkrf-mo3 img:first-child{grid-row:span 2}'
    + '#lk-drawer .lkrf-mo5,#lk-drawer .lkrf-mo6{grid-template:1fr 1fr/1fr 1fr 1fr}#lk-drawer .lkrf-mo5 img:first-child{grid-row:span 2}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function fmt(c, cur) {
    var x = (c || 0) / 100, k = cur || D.cur || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: k, currencyDisplay: 'narrowSymbol' }).format(x); } catch (e) {}
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: k }).format(x); } catch (e) {}
    return '$' + x.toFixed(2);
  }
  function designs(it) { var p = it.properties && it.properties['Chosen designs']; return p ? String(p) : ''; }
  function len(it) { return (it.properties && it.properties['Length']) || ''; }
  function count(d) { return d.split(',').filter(function (x) { return x.trim(); }).length; }
  /* Sets in a kit line come from its variant (Debut 1, Glow-Up 3, Nail Wardrobe 6, 'N Sets' N). Design names can carry
     multipliers ('Milky Nude x2'), so counting names is wrong for stepper and 12-set kits. */
  function setsOf(it) {
    var vt = String(it.variant_title || '');
    if (vt === 'The Debut') return 1; if (vt === 'The Glow-Up') return 3; if (vt === 'The Nail Wardrobe') return 6;
    var m = /^(\d+) Sets?$/.exec(vt); return m ? +m[1] : count(designs(it));
  }
  function expand(d) {   /* 'Milky Nude x2, Plum' -> ['Milky Nude','Milky Nude','Plum'] */
    var out = []; d.split(',').forEach(function (x) { x = x.trim(); if (!x) return; var m = /^(.*?)\s+x(\d+)$/i.exec(x); var n = m ? +m[2] : 1, nm = m ? m[1] : x; for (var i = 0; i < n; i++) out.push(nm); });
    return out;
  }
  function isKit(it) { return (it.handle || '') === D.kit; }
  function isRf(it) { return (it.handle || '') === D.h; }
  function isRf2(it) { return !!D.h2 && (it.handle || '') === D.h2; }
  function rfParts(it) { return String(it.variant_title || '').split(' / '); }   /* ["Blush Pink","Short","Refill of 3"] */
  function rfDesign(it) { return (rfParts(it)[0] || '').trim(); }
  function rfLen(it) { return (rfParts(it)[1] || '').trim(); }
  function rfTier(it) { var m = /(\d+)/.exec(rfParts(it)[2] || ''); return m ? +m[1] : 0; }   /* "Refill of 3" -> 3 */
  /* keep only the lines (and quantities) that this kit's designs account for; null if the kit is not fully covered */
  function fitTo(kit, lines) {
    var need = {}, upd = {}, keep = [], changed = false;
    expand(designs(kit)).forEach(function (d) { need[d] = (need[d] || 0) + 1; });
    lines.forEach(function (x) {
      var d = rfDesign(x), n = need[d] || 0;
      if (n <= 0) { upd[x.key] = 0; changed = true; return; }
      var q = Math.min(n, x.quantity); need[d] = n - q;
      if (q < x.quantity) { upd[x.key] = q; changed = true; }
      keep.push(x);
    });
    for (var d in need) if (need[d] > 0) return null;
    return { keep: keep, upd: upd, changed: changed };
  }
  function msig(names, L) { return names.slice().sort().join(',') + '|' + L; }   /* order-free designs signature */
  function kitMsig(it) { return msig(expand(designs(it)), len(it) || 'Medium Almond'); }
  function dropKeys(keys) {   /* remove several lines in ONE cart change (goes through the queue above); a map = exact quantities */
    var u = {}; if (Array.isArray(keys)) keys.forEach(function (k) { u[k] = 0; }); else u = keys;
    var done = function () { if (window.lkRender) window.lkRender(); };
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }).then(done, done);
  }
  function sig(it) { return designs(it).replace(/\s+/g, ' ').trim() + '|' + len(it); }

  var items = null, busy = false, again = false;

  /* The drawer shares the exact cart it just drew (window.__lkCart, set in renderCart before the lines are written),
     so the strip and the tidy lines go in before the browser paints: no flash, no second request. */

  /* The refill line shows HER designs (the kit picker's own swatch photos, short or almond), not one stock colour.
     Unknown design name -> keep the neutral all-designs product photo. */
  function swatch(name, short) {
    var sel = '.lk-sw[data-id="' + ((window.CSS && CSS.escape) ? CSS.escape(name) : name.replace(/"/g, '')) + '"] img';
    var el = document.querySelector(sel); if (!el) return '';
    /* the page swaps each swatch's src to the current length, so read the stored photos: data-short / data-long */
    return (short ? el.getAttribute('data-short') : el.getAttribute('data-long')) || el.getAttribute('src') || '';
  }
  function mosaic(n, it) {
    var img = n.querySelector('img'); if (!img || img.getAttribute('data-lkrf-mo')) return;
    var names = expand(designs(it)), short = /short/i.test(len(it));
    var srcs = names.slice(0, 6).map(function (x) { return swatch(x, short); });
    if (!srcs.length || srcs.some(function (x) { return !x; })) return;
    var cs = getComputedStyle(img), mo = document.createElement('div');
    mo.className = 'lkrf-mo lkrf-mo' + srcs.length;
    ['width', 'height', 'borderRadius', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'alignSelf'].forEach(function (p) { mo.style[p] = cs[p]; });
    srcs.forEach(function (x) { var i = document.createElement('img'); i.src = x; i.alt = ''; i.loading = 'lazy'; mo.appendChild(i); });
    img.style.display = 'none'; img.setAttribute('data-lkrf-mo', '1');
    img.parentNode.insertBefore(mo, img);
  }

  function rowFor(it, cur) {
    var d = designs(it), k = setsOf(it);
    if (!d || !D.n || k < 1 || k > 6) return null;
    var L = len(it) || 'Medium Almond', names = expand(d);
    if (names.length !== k) return null;
    var cnt = {}, order = [];
    names.forEach(function (x) { if (!cnt[x]) { cnt[x] = 0; order.push(x); } cnt[x]++; });
    var lines = [], per = 0, total = 0;
    for (var i = 0; i < order.length; i++) {
      var V = D.n[order[i] + '|' + L + '|Refill of ' + k]; if (!V) return null;   /* unknown design: no offer */
      per = V.p; total += V.p * cnt[order[i]];
      lines.push({ id: V.id, quantity: cnt[order[i]] });   /* no properties: the variant title says design / length */
    }
    var row = document.createElement('div'); row.className = 'lkrf-row';
    var line = k === 1
      ? 'Same design, for when this one comes off'
      : 'Same ' + k + ' designs, for when these come off \u00b7 ' + fmt(per, cur) + ' a set';
    row.innerHTML = '<span class="lkrf-flag">Only with this order</span><div class="lkrf-tx"><b>Your first refill, ready</b><span></span></div><button type="button" class="lkrf-add"></button>';
    row.querySelector('.lkrf-tx span').textContent = line;
    var b = row.querySelector('button'), label = '+ Add ' + fmt(total, cur);
    b.textContent = label;
    b.onclick = function () {
      b.disabled = true; b.textContent = 'Adding\u2026';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lines }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { ping('rfadd'); if (window.lkRender) window.lkRender(); })
        .catch(function () { b.disabled = false; b.textContent = label; });
    };
    return row;
  }

  /* One drawer row for all color lines of one refill: 'Refill Nails (nails only) / 3 Sets / Designs / Length / total'. */
  function groupNode(n, lines, r, cur, kit) {
    var qty = 0, sum = 0, keys = [], per = {}, names = [];
    lines.forEach(function (x) { qty += x.quantity; sum += x.final_line_price; keys.push(x.key); var d = rfDesign(x); if (!per[d]) { per[d] = 0; names.push(d); } per[d] += x.quantity; });
    if (kit) { var ko = [], seenK = {}; expand(designs(kit)).forEach(function (d) { if (!seenK[d] && per[d]) { seenK[d] = 1; ko.push(d); } }); if (ko.length === names.length) names = ko; }   /* her picker order */
    var ds = names.map(function (d) { return d + (per[d] > 1 ? ' x' + per[d] : ''); }).join(', '), L = rfLen(lines[0]);
    n.classList.add('lkrf-q1'); n.classList.add('lkrf-g');
    var nm = n.querySelector('.lk-diname'); if (nm) nm.textContent = 'Refill Nails (nails only)';
    var op = n.querySelector('.lk-diopt'); if (op) op.textContent = qty + (qty === 1 ? ' Set' : ' Sets');
    var pr = n.querySelectorAll('.lk-diprops');
    if (pr.length < 2 && op) {   /* lines without properties: the drawer drew no Designs/Length rows, add them */
      var meta = op.parentNode, after = op;
      for (var pi = pr.length; pi < 2; pi++) { var dv = document.createElement('div'); dv.className = 'lk-diprops'; after.insertAdjacentElement('afterend', dv); after = dv; }
      pr = meta.querySelectorAll('.lk-diprops');
    }
    if (pr[0]) pr[0].textContent = 'Designs: ' + ds; if (pr[1]) pr[1].textContent = 'Length: ' + L;
    var pc = n.querySelector('.lk-diprice'); if (pc) pc.textContent = fmt(sum, cur);
    var rm = n.querySelector('.lk-dirm');
    if (rm) { rm.removeAttribute('onclick'); rm.onclick = function () { rm.disabled = true; dropKeys(keys); }; }
    mosaic(n, { properties: { 'Chosen designs': ds, 'Length': L } });
  }

  /* Small phones: if the strip under the kit would push an add-on she just chose (remover, glue) out of view,
     move the strip below the last cart line. Big enough phones keep it right under the kit. */
  function arrange() {
    var rows = items.querySelectorAll(':scope > .lkrf-row'), adds = items.querySelectorAll(':scope > .lk-ditem.lkrf-c');
    if (!rows.length || !adds.length) return;
    var last = adds[adds.length - 1], lt = items.getBoundingClientRect().top;
    var bottom = (last.querySelector('.lk-dimeta') || last).getBoundingClientRect().bottom - lt + items.scrollTop;   /* her text, not the row's bottom padding */
    if (bottom <= items.clientHeight) return;
    var lines = items.querySelectorAll(':scope > .lk-ditem'), end = lines[lines.length - 1];
    for (var i = rows.length - 1; i >= 0; i--) end.insertAdjacentElement('afterend', rows[i]);
  }

  function process() {
    if (busy) { again = true; return; }
    busy = true;
    var shown = items.querySelectorAll(':scope > .lk-ditem').length;
    var wc = window.__lkCart;
    var src = (wc && (wc.items || []).length === shown) ? Promise.resolve(wc)
      : fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    src
      .then(function (c) {
        var its = c.items || [], cur = c.currency || D.cur;
        if (!D.preview && !forced && (!c.attributes || c.attributes[ATTR] !== v)) {
          var a = {}; a[ATTR] = v;
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {});
        }
        var kits = {}, have = {}, orphan = null, orph2 = [], grp = {}, byLen = {};
        its.forEach(function (it) { if (isKit(it)) kits[kitMsig(it)] = it; });
        its.forEach(function (it) {
          if (isRf(it)) { have[sig(it)] = 1; if (!kits[sig(it)] && !orphan) orphan = it; }
          if (isRf2(it)) { var g2 = rfLen(it) + '|' + rfTier(it); (byLen[g2] = byLen[g2] || []).push(it); }
        });
        /* the color lines of one length + refill size form one refill; it belongs to the kit with those designs, length, size */
        var fix = null;
        Object.keys(byLen).forEach(function (g2) {
          var L2 = g2.split('|')[0], k2 = +g2.split('|')[1], ls = byLen[g2], names = [];
          ls.forEach(function (x) { for (var q = 0; q < x.quantity; q++) names.push(rfDesign(x)); });
          var r = msig(names, L2), kitsL = its.filter(function (k) { return isKit(k) && (len(k) || 'Medium Almond') === L2 && setsOf(k) === k2; });
          if (kits[r]) { have[r] = 1; grp[r] = ls; ls.forEach(function (x) { x.__lkr = r; }); return; }
          if (kitsL.length >= 2) { ls.forEach(function (x) { x.__lkr = 'solo:' + x.key; grp[x.__lkr] = [x]; }); return; }   /* 2 same kits (rare): never drop, show each line on its own */
          var f = kitsL.length === 1 ? fitTo(kitsL[0], ls) : null;
          if (f && f.changed && !fix) fix = f.upd;   /* leftovers from a removed kit: trim to what this kit needs */
          else if (f) { var rk = kitMsig(kitsL[0]); have[rk] = 1; grp[rk] = ls; ls.forEach(function (x) { x.__lkr = rk; }); }
          else ls.forEach(function (x) { orph2.push(x.key); });
        });
        if (fix) { dropKeys(fix); return; }
        if (orph2.length) { dropKeys(orph2); return; }   /* color lines whose kit is gone: remove them all at once */
        if (orphan && window.lkQty) { window.lkQty(orphan.key, 0); return; }   /* refill without its kit: remove */
        if (its.some(isKit)) once('kitcart');
        var ordered = its.slice().sort(function (x, y) { return (isKit(x) ? 0 : 1) - (isKit(y) ? 0 : 1); });
        var nodes = items.querySelectorAll(':scope > .lk-ditem');
        if (nodes.length !== ordered.length) return;
        var seen = {};
        ordered.forEach(function (it, i) {
          var n = nodes[i]; n.setAttribute('data-lkrf', '1');
          var nx = n.nextElementSibling; if (nx && nx.classList.contains('lkrf-row')) nx.parentNode.removeChild(nx);
          if (isRf2(it)) { var r = it.__lkr; if (seen[r]) { n.style.display = 'none'; return; } seen[r] = 1; groupNode(n, grp[r] || [it], r, cur, kits[r]); return; }
          if (isRf(it)) { mosaic(n, it); var rn = n.querySelector('.lk-diname'); if (rn) rn.textContent = String(rn.textContent).replace(/^LoveSKN\s+/i, ''); return; }
          if (isKit(it)) { n.classList.add('lkrf-k'); var kn = n.querySelector('.lk-diname'); if (kn) kn.textContent = String(kn.textContent).replace(/^The\s+/, ''); }
          if (!isKit(it)) { n.classList.add('lkrf-c'); if (it.quantity === 1) n.classList.add('lkrf-q1'); var nm = n.querySelector('.lk-diname'); if (nm) nm.textContent = String(nm.textContent).replace(/^LoveSKN\s+(Press-On\s+)?/i, ''); }
          if (v !== 'b' || !isKit(it) || have[kitMsig(it)]) return;
          var row = rowFor(it, cur); if (!row) return;
          n.insertAdjacentElement('afterend', row); once('rfshow');
        });
        arrange();
        /* header count: a refill counts as 1 item, like before (not 1 per color line) */
        try {
          var extra = 0, g = 0; for (var gk in grp) { g++; grp[gk].forEach(function (x) { extra += x.quantity; }); }
          if (g) { var ci = document.querySelector('cart-icon'); if (ci && typeof ci.renderCartBubble === 'function') ci.renderCartBubble((c.item_count || 0) - extra + g, false, false); }
        } catch (e) {}
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; process(); } });
  }

  function check() {
    if (!items || !items.querySelector(':scope > .lk-ditem:not([data-lkrf])')) return;
    /* addToCart draws a temporary kit line before Shopify confirms the add. Every real line (renderCart) carries a
       .lk-diopt div, the temporary one never does (the free 3-jar remover has no qty stepper, so .lk-diqty can't be used).
       Act only on the real render, never on the temporary one. */
    var all = items.querySelectorAll(':scope > .lk-ditem');
    for (var i = 0; i < all.length; i++) if (!all[i].querySelector('.lk-diopt')) return;
    process();
  }
  function init() {
    items = document.getElementById('lk-ditems'); if (!items) return;
    new MutationObserver(check).observe(items, { childList: true });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
